// src/features/assets/services/assetResearchService.js
import apiClient from "../../../service/apiClient";
import { ASSET_RESEARCH_ENDPOINTS } from "../../../app/apiEndpoints";

// data APIs
export const getInvestorsByContact = (contactId) =>
  apiClient.get(ASSET_RESEARCH_ENDPOINTS.GET_INVESTOR_BY_CONTACT, {
    params: { contactId, addSelect: true, isAsset: false },
  });

export const downloadDocumentBlob = (documentId, isRejected = false, userId = 0, appRoleId = 0) =>
apiClient.get(ASSET_RESEARCH_ENDPOINTS.GET_RESEARCH_DOCUMENT_BY_ID, {
  params: { documentId, isRejected, userId, appRoleId },
  responseType: "blob",
});

export const getResearchEntitiesByInvestor = (investorId, contactId) =>
  apiClient.get(ASSET_RESEARCH_ENDPOINTS.GET_RESEARCH_ENTITIES_BY_INVESTOR, {
    params: { investorId, contactId, addSelect: true },
  });

export const getResearchCategoriesByEntity = ({
  investorId,
  entityId,
  entityTypeId,
  contactId,
}) =>
  apiClient.get(ASSET_RESEARCH_ENDPOINTS.GET_RESEARCH_CATEGORIES_BY_ENTITY, {
    params: {
      investorId,
      entityId,
      entityTypeId,
      documentGroup: 0,
      contactId,
    },
  });

export const getResearchDocumentsByFilters = (payload) =>
  apiClient.get(ASSET_RESEARCH_ENDPOINTS.GET_RESEARCH_DOCUMENTS_BY_ENTITY, {
    params: payload,
  });


// single document download (blob)

export const downloadResearchDocumentBlob = (
  documentId,
  userId = 0,
  appRoleId = 1
) =>
  apiClient.get(ASSET_RESEARCH_ENDPOINTS.GET_RESEARCH_DOCUMENT_BY_ID, {
    params: { documentId, userId, appRoleId },
    responseType: "blob",
  });

export const getResearchDocumentNameById = (documentId) =>
  apiClient.get(
    `${ASSET_RESEARCH_ENDPOINTS.GET_RESEARCH_DOCUMENT_NAME_BY_ID}/${documentId}`
  );


// customize settings

export const getResearchDocumentsCustomize = (
  PageId = 5,
  UserId = 0,
  Name = "Default_User",
  isResearchDocument = true
) =>
  apiClient.get(
    `${ASSET_RESEARCH_ENDPOINTS.GET_DOCUMENTS_CUSTOMIZE}/${PageId},${UserId},${encodeURIComponent(
      Name
    )},${isResearchDocument}`
  );


// save customize settings

export const saveResearchDocumentsCustomize = (payload) =>
  apiClient.post(
    ASSET_RESEARCH_ENDPOINTS.SAVE_GRID_CUSTOMIZE_COLUMNS,
    payload
  );


// zip download

export const downloadResearchZipBlob = (
  documentIds,
  userId = 0,
  appRoleId = 1,
  fileName = "ResearchDocuments"
) =>
  apiClient.get(ASSET_RESEARCH_ENDPOINTS.GET_RESEARCH_ZIP_DOWNLOAD, {
    params: {
      documentIds: Array.isArray(documentIds)
        ? documentIds.join(",")
        : String(documentIds),
      userId,
      appRoleId,
      fileName,
    },
    responseType: "blob",
  });


// MVC URL helpers

export const getClientResearchDocumentDownloadUrl = (params) =>
  `${ASSET_RESEARCH_ENDPOINTS.GET_CLIENT_RESEARCH_DOCUMENTS_DOWNLOAD}?${new URLSearchParams(
    params
  ).toString()}`;

export const getClientResearchDocumentsSinglePDFDownloadUrl = (params) =>
  `${ASSET_RESEARCH_ENDPOINTS.GET_CLIENT_RESEARCH_DOCUMENTS_SINGLE_PDF_DOWNLOAD}?${new URLSearchParams(
    params
  ).toString()}`;

export const getResearchDocumentAsSingleZipDownloadUrl = (params) =>
  `${ASSET_RESEARCH_ENDPOINTS.GET_RESEARCH_DOCUMENTS_ZIP_DOWNLOAD}?${new URLSearchParams(
    params
  ).toString()}`;


// blob utils

export const openBlobInNewTab = (blob) => {
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
};
  
